import {
  GET_EVENEMENTS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  UPDATE_EVENEMENT,
  UPDATE_EVENEMENT_SUCCESS,
  UPDATE_EVENEMENT_FAIL,
  ADD_NEW_EVENEMENT,
  ADD_EVENEMENT_SUCCESS,
  ADD_EVENEMENT_FAIL,
} from "./actionType";

// common success
export const evenementApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const evenementApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getEvenements = () => ({
  type: GET_EVENEMENTS,
});

export const updateEvenement = (evenement) => ({
  type: UPDATE_EVENEMENT,
  payload: evenement,
});

export const updateEvenementSuccess = (evenement) => ({
  type: UPDATE_EVENEMENT_SUCCESS,
  payload: evenement,
});

export const updateEvenementFail = (error) => ({
  type: UPDATE_EVENEMENT_FAIL,
  payload: error,
});

export const addNewEvenement = (evenement) => ({
  type: ADD_NEW_EVENEMENT,
  payload: evenement,
});

export const addEvenementSuccess = (evenement) => ({
  type: ADD_EVENEMENT_SUCCESS,
  payload: evenement,
});

export const addEvenementFail = (error) => ({
  type: ADD_EVENEMENT_FAIL,
  payload: error,
});
